"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultSettings = exports.TextFieldType = void 0;
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var configurationTypes_1 = require("../../../shared/types/configurationTypes");
var react_redux_1 = require("react-redux");
var crude_selector_1 = require("../../../store/crude/crude.selector");
var CrudeTextInputTrash_1 = __importDefault(require("../../../screens/DataEditView/FormComponents/utils/CrudeTextInputTrash"));
var getColumnEditLayout_1 = __importDefault(require("../../../shared/util/getColumnEditLayout"));
var LabelWithTooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/LabelWithTooltipComponent"));
var getValueForColumn_1 = __importDefault(require("../util/getValueForColumn"));
var TooltipComponent_1 = __importDefault(require("../../../shared/components/MessageComponents/TooltipComponent"));
var TextFieldType;
(function (TextFieldType) {
    TextFieldType["text"] = "text";
    TextFieldType["number"] = "number";
    TextFieldType["password"] = "password";
    TextFieldType["tel"] = "tel";
})(TextFieldType = exports.TextFieldType || (exports.TextFieldType = {}));
exports.defaultSettings = {
    color: 'primary',
    disabled: false,
    variant: 'outlined',
    type: TextFieldType.text,
    margin: 'dense',
};
var CrudeTextInputComponent = function (props) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    var theme = material_1.useTheme();
    var entity = props.entity;
    var appLayout = react_redux_1.useSelector(crude_selector_1.getAppLayout);
    var editLayout = react_redux_1.useSelector(crude_selector_1.getEditLayout);
    var crudeLanguage = react_redux_1.useSelector(crude_selector_1.getLanguage);
    var crudeLabels = react_redux_1.useSelector(crude_selector_1.getCrudeLabels)[crudeLanguage];
    var crudeConfig = react_redux_1.useSelector(crude_selector_1.getCrudeConfiguration);
    var variant = ((_a = appLayout.textfield) === null || _a === void 0 ? void 0 : _a.type) || exports.defaultSettings.variant;
    var margin = ((_b = appLayout.textfield) === null || _b === void 0 ? void 0 : _b.margin) ? (_c = appLayout.textfield) === null || _c === void 0 ? void 0 : _c.margin : exports.defaultSettings.margin;
    var type = props.type || exports.defaultSettings.type;
    var columnName = props.schema.name;
    var columnLabels = (_e = (_d = crudeLabels === null || crudeLabels === void 0 ? void 0 : crudeLabels.app[crudeConfig.api.app]) === null || _d === void 0 ? void 0 : _d.entity[entity]) === null || _e === void 0 ? void 0 : _e.columns;
    var label = (columnLabels && ((_f = columnLabels[columnName]) === null || _f === void 0 ? void 0 : _f.title)) ? (_g = columnLabels[columnName]) === null || _g === void 0 ? void 0 : _g.title : columnName;
    var description = columnLabels && ((_h = columnLabels[columnName]) === null || _h === void 0 ? void 0 : _h.description);
    var required = !props.schema.nullable;
    var disabled = props.disabled ? props.disabled : false;
    var _k = react_1.default.useState(getValueForColumn_1.default(props.schema, props.data, columnLabels)), value = _k[0], setValue = _k[1];
    react_1.useEffect(function () {
        setValue(getValueForColumn_1.default(props.schema, props.data, columnLabels));
    }, [props.data]);
    var _l = react_1.useState(props.columnEditLayout || (editLayout && getColumnEditLayout_1.default(entity, columnName || '', editLayout))), columnEditLayout = _l[0], setColumnEditLayout = _l[1];
    react_1.useEffect(function () {
        setColumnEditLayout(props.columnEditLayout);
    }, [props.columnEditLayout]);
    var multiline = ((_j = appLayout.globalInputLayouts) === null || _j === void 0 ? void 0 : _j.string) === configurationTypes_1.StringLayout.multiline || (columnEditLayout === null || columnEditLayout === void 0 ? void 0 : columnEditLayout.layout) === configurationTypes_1.StringLayout.multiline;
    var changeData = function (value) {
        var newData = props.data;
        var newColumnData = newData.data;
        newColumnData[columnName] = value;
        newData.data = newColumnData;
        return newData;
    };
    var onTrashClick = function (event) {
        event.stopPropagation();
        setValue('');
        props.onChange && changeData('') && props.onChange(changeData(''));
    };
    var Element = function () {
        var _a, _b;
        return (react_1.default.createElement(material_1.TextField, { name: columnName, InputProps: {
                endAdornment: (react_1.default.createElement(react_1.default.Fragment, null,
                    ((props.clearable && value) || (!required && value && !disabled)) &&
                        react_1.default.createElement(CrudeTextInputTrash_1.default, { onTrashClick: function (event) { return onTrashClick(event); } }),
                    react_1.default.createElement(react_1.default.Fragment, null, props.endIcon))),
                readOnly: disabled,
                disabled: disabled,
            }, "aria-label": label, label: react_1.default.createElement(LabelWithTooltipComponent_1.default, { label: label, description: description }), InputLabelProps: {
                shrink: true,
                style: { pointerEvents: 'auto', display: 'flex', alignItems: 'center', color: "" + theme.palette.text.secondary },
            }, variant: variant, required: required, disabled: disabled, type: type, minRows: multiline && ((_a = appLayout.textfield) === null || _a === void 0 ? void 0 : _a.minRows) ? (_b = appLayout.textfield) === null || _b === void 0 ? void 0 : _b.minRows : 1, sx: {
                width: props.fullWidth ? '100%' : '300px',
                '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
                    borderColor: theme.palette.primary.main,
                    borderWidth: 2,
                },
                '& .MuiOutlinedInput-root .Mui-disabled': {
                    '-webkit-text-fill-color': props.notDisabledValue ? "" + theme.palette.text.primary : theme.palette.text.disabled,
                    color: props.notDisabledValue ? "" + theme.palette.text.primary : theme.palette.text.disabled,
                },
            }, margin: margin, autoFocus: false, multiline: multiline, value: value, onChange: (function (event) {
                var val = event.target.value || '';
                setValue(val);
                props.onChange && changeData(val) && props.onChange(changeData(val));
            }) }));
    };
    return (react_1.default.createElement(react_1.default.Fragment, null, props.showTooltip
        ? (react_1.default.createElement(TooltipComponent_1.default, { title: getValueForColumn_1.default(props.schema, props.data, columnLabels), placement: 'bottom-start', element: Element() }))
        : react_1.default.createElement(react_1.default.Fragment, null, Element())));
};
exports.default = CrudeTextInputComponent;
